import {ValueObject} from '@s-ui/domain'

export class UserAlertIdValueObject extends ValueObject {
  /**
   * @param {Number} alertId
   */

  getAlertId() {
    return this._alertId
  }
}
